import { ScaleQuantize } from 'd3-scale';

import { RangeItem } from '../components/legend/range/types/range-legend.js';

/**
 * Defines the items to render a quantized legend
 *
 * @internal
 *
 * @param scale - scale to be used a quantized legend
 * @param invertItems - If true, items are returned inverted
 */
export const buildQuantizedRangeItems = (
  scale: ScaleQuantize<string>,
  invertItems = false,
): RangeItem[] => {
  const range = invertItems ? scale.range().reverse() : scale.range();

  return range.map((color: string) => {
    const [from, to] = scale.invertExtent(color);

    return {
      from,
      to,
      color,
    };
  });
};
